export default function Infrastructure() {
    return (
        <div className="max-w-7xl mx-auto px-6 py-16">
            <h1 className="text-3xl font-bold text-[#7a0c18]">Infrastructure</h1>
            <p className="mt-4">Modern machines & hygienic plant.</p>
        </div>
    );
}
